import { FsCore } from '../../types/fs-core'

export const filtersState = (s: FsCore.State) => s.filters

export function getFilterGroup(s: FsCore.State, key: string): FsCore.FilterGroupState | undefined {
  return filtersState(s)[key]
}
